/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u45m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing a university lecture or class period.`)
};

const es_timer_u45m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar una clase o período lectivo universitario.`)
};

const de_timer_u45m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Universitätsvorlesung oder Unterrichtsstunde stoppen.`)
};

const nl_timer_u45m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een universitair college of lesuur timen.`)
};

const fr_timer_u45m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chronométrer un cours universitaire ou une période de classe.`)
};

const it_timer_u45m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrare una lezione universitaria o un'ora di lezione.`)
};

const pt_br2_timer_u45m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar uma aula ou período de classe universitário.`)
};

const pt_timer_u45m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar uma aula universitária ou um período letivo.`)
};

const ja_timer_u45m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大学の講義やクラスの時間を計測する。`)
};

const zh_timer_u45m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为大学讲座或课堂时长计时。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u45m_use1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u45m_use1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u45m_use1", locale)
	if (locale === "en") return en_timer_u45m_use1(inputs)
	if (locale === "es") return es_timer_u45m_use1(inputs)
	if (locale === "de") return de_timer_u45m_use1(inputs)
	if (locale === "nl") return nl_timer_u45m_use1(inputs)
	if (locale === "fr") return fr_timer_u45m_use1(inputs)
	if (locale === "it") return it_timer_u45m_use1(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u45m_use1(inputs)
	if (locale === "pt") return pt_timer_u45m_use1(inputs)
	if (locale === "ja") return ja_timer_u45m_use1(inputs)
	return zh_timer_u45m_use1(inputs)
};